/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Materials_PesticideInputs */

const vi_care_log_materials_pesticide = /** @type {(inputs: Care_Log_Materials_PesticideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thuốc bảo vệ thực vật`)
};

/**

* @param {Care_Log_Materials_PesticideInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_materials_pesticide = /** @type {((inputs?: Care_Log_Materials_PesticideInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Materials_PesticideInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_materials_pesticide(inputs)
});